var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9997 7.52667C12.8948 8.66147 12.469 9.74294 11.7719 10.6445C11.0748 11.5461 10.1354 12.2305 9.06352 12.6177C7.99166 13.0049 6.83171 13.0787 5.71939 12.8307C4.60707 12.5827 3.58838 12.023 2.78254 11.2172C1.97669 10.4113 1.41701 9.39265 1.16899 8.28033C0.920971 7.16801 0.994865 6.00806 1.38203 4.9362C1.76919 3.86434 2.45361 2.92491 3.3552 2.22784C4.25678 1.53076 5.33825 1.10487 6.47305 1C5.80866 1.89884 5.48895 3.0063 5.57207 4.12094C5.6552 5.23559 6.13563 6.28337 6.92599 7.07373C7.71635 7.86409 8.76413 8.34452 9.87878 8.42765C10.9934 8.51077 12.1009 8.19106 12.9997 7.52667Z","stroke":"#6D6D6D","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Moon.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Moon;

Moon.default = Moon;
